import React from 'react';
import { StyledLinkedResultSnippet } from 'components/common/search/LinkedResultSnippets';
import styled from 'styled-components';
import { GenericSearchEdge } from '__generated__/graphql';
import { useSearchParams } from 'react-router-dom';
import { CourtRuleLink } from 'features/link-helpers/CourtRuleLink';
import { StyledResultTitle } from 'pages/search/SearchResult';

export function CourtRulesResult({
  result,
  className,
}: {
  result: GenericSearchEdge;
  className?: string;
}) {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('query');

  const { snippets } = result;

  const { id, title, type } = React.useMemo(() => {
    const rule = result.node;
    const id = rule?.documentId || '';
    const title = rule?.name || '';
    const isLocal = (id || '').match(/^LRC/) ? true : false;
    const type = isLocal ? ('local' as const) : ('ca' as const);

    return { id, title, isLocal, type };
  }, [result]);

  return (
    <StyledResult className={className || ''}>
      <header>
        <StyledResultTitle>
          <CourtRuleLink id={id} type={type} query={query || undefined}>
            {title}
          </CourtRuleLink>
        </StyledResultTitle>
      </header>
      <div className="snippets">
        <StyledLinkedResultSnippet>
          {(snippets || []).map((snippet, i) => (
            <CourtRuleLink
              key={snippet?.position}
              id={id}
              type={type}
              query={query || undefined}
              hash={snippet?.position}
            >
              <span
                dangerouslySetInnerHTML={{
                  __html: snippet?.text || '',
                }}
              />
            </CourtRuleLink>
          ))}
        </StyledLinkedResultSnippet>
      </div>
    </StyledResult>
  );
}

const StyledResult = styled.li`
  margin: 0 32px 25px;
  padding: 7px 0;

  header {
    margin-bottom: 10px;
    h3 {
      a,
      a:visited {
        color: var(--COLOR_NICE_BLUE);
      }
      margin-bottom: 0;
      position: relative;
    }
  }
  .snippets {
    > span {
      > a,
      > span {
        line-height: 1.25;
        margin-bottom: 12px;
      }
    }
  }

  span a {
    display: block;
  }
`;
